import React, { FunctionComponent } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

import { PlateDetailSettings } from '@paragon/contract-library';

interface Props {
  value: PlateDetailSettings;
  onChange: (value: PlateDetailSettings) => void;
  disabled?: boolean;
}

export const PlateDetailSettingsComponent: FunctionComponent<Props> = ({ value, onChange, disabled }) => {
  const toggle = (property: keyof PlateDetailSettings) => () => onChange({ ...value, [property]: !value[property] });

  return (
    <>
      <FormControlLabel
        control={<Checkbox color="default" checked={value.showPlateDetails} onChange={toggle('showPlateDetails')} />}
        label="Show Plate Details"
        disabled={disabled}
      />

      <FormControlLabel
        label="Hide most common type"
        control={
          <Checkbox color="default" checked={value.hideForMostCommonType} onChange={toggle('hideForMostCommonType')} />
        }
        sx={{ ml: 2 }}
        disabled={disabled || !value.showPlateDetails}
      />

      <FormControlLabel
        label="Hide most common size"
        control={
          <Checkbox color="default" checked={value.hideForMostCommonSize} onChange={toggle('hideForMostCommonSize')} />
        }
        sx={{ ml: 2 }}
        disabled={disabled || !value.showPlateDetails}
      />
    </>
  );
};
